import React from 'react';
import { GraphQLClient } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import {
  GetLatestNewsByTagDocument,
  GetLatestNewsByTagQuery
} from '../../../../codegenGenerated/optigraphql/generated';
import Loader from '../Loader';
import { getEnvGQLUrl } from '../../../helpers';

const useGetLatestNews = (endpoint: string, tag: string) => {
  const graphQLClient = new GraphQLClient(endpoint);

  const { isError, error, isFetching, data } = useQuery({
    queryKey: ['GetLatestNewsByTag', { tag: tag }],
    queryFn: async () =>
      graphQLClient.request(GetLatestNewsByTagDocument, {
        tag: tag
      }) as GetLatestNewsByTagQuery,
    refetchOnWindowFocus: false
  });

  return {
    status: isError ? 'error' : isFetching ? 'loading' : 'success',
    error: error as Error,
    results: data && data.ArticleDetailPage?.items ? data.ArticleDetailPage.items : []
  };
};

export type LatestNewsProps = {
  title: string;
  tag: string;
  imgFallback?: string;
};

export const LatestNews = ({ title, tag, imgFallback }: LatestNewsProps) => {
  const { status, results } = useGetLatestNews(getEnvGQLUrl(), tag);

  if (status === 'loading') {
    return <Loader />;
  }

  return (
    <>
      {status === 'error' && <></>}
      {results.length === 0 && <></>}
      {results.length > 0 && (
        <>
          <h4 className="resources-menu__news-title">{title}</h4>
          {results.map(result => (
            <a
              className="resources-menu__news-card"
              href={(result!.OverrideCardLink?.Href as string) ?? result!.Url}
              target={(result!.OverrideCardLink?.Target as string) ?? ''}
              title={(result!.OverrideCardLink?.Title as string) ?? result!.Title}
              key={result?._id}
            >
              <div className="picture">
                <img
                  className="resources-menu__news-card-image"
                  src={result?.BlogAndNewsImage?.Url ?? imgFallback}
                  alt="about-card-image"
                  loading="lazy"
                  width="208"
                  height="150"
                />
              </div>
              <div className="resources-menu__news-content">
                {result?.Title && (
                  <h5 className="resources-menu__news-content-title">
                    {result?.Title}
                    <div className="btn-decorator">
                      <span className="btn-decorator-inner"></span>
                      <span className="btn-decorator-outer"></span>
                    </div>
                  </h5>
                )}
                <p className="resources-menu__news-copy">{result?.FeaturedDescription}</p>
              </div>
            </a>
          ))}
        </>
      )}
    </>
  );
};
